import { ReactElement } from 'react'
import NumberOfPeopleTemplate from './template'
import { useSteps } from '../../../../contexts/stepContext'
import { useBFSMValue } from '../../../../services/hooks/useBFSMValues'
import {
    CompanyActions,
    CompanyLeadState,
} from '@raskrask-dk/bookingflow-state-machine'

const NumberOfPeoplePage = (): ReactElement => {
    const [currentStep, helpers] = useSteps()

    const [companySettings, setCompanySettings] = useBFSMValue<
        CompanyLeadState,
        CompanyActions.SetCompanySettings,
        'companySettings'
    >('companySettings', CompanyActions.SetCompanySettings)

    const onChangeNumOfP = (e: React.ChangeEvent<HTMLInputElement>) =>
        setCompanySettings({
            ...companySettings,
            amountOfPeople: e.currentTarget.value,
        })

    const prop = companySettings?.amountOfPeople

    return (
        <NumberOfPeopleTemplate
            amountOfPeople={prop}
            currentStep={currentStep}
            dataCy="accordion-numberofpeople"
            helpers={helpers}
            onChangeNumOfP={onChangeNumOfP}
        />
    )
}
export default NumberOfPeoplePage
